import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import SignUpLayout from './SignUpLayout';
import './SignUp.css';

const SignUp = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { signIn, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if already signed in
  useEffect(() => {
    if (user) {
      navigate('/overview');
    }
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Store email for OTP verification
      localStorage.setItem('userEmail', email);
      
      // We'll check if the user exists after OTP verification
      // This avoids making multiple auth requests in quick succession
      localStorage.setItem('isSignUp', 'true');
      
      // Send OTP for verification
      await signIn(email);
      navigate('/verify');
    } catch (err: any) {
      setError(err.message || 'Failed to process request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <SignUpLayout
      title="Create your account"
      subtitle="Join Texta and start writing better"
      currentStep={1}
      totalSteps={4}
      footer={
        <>
          Already have an account?{' '}
          <a href="/login" className="signup-link">
            Sign in
          </a>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="signup-form">
        <div className="signup-form-fields">
          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            error={error}
            sizeVariant="large"
            required
          />
        </div>
        
        <Button 
          type="submit" 
          className="signup-button"
          variant="primary"
          size="large"
          disabled={loading}
          isLoading={loading}
        >
          Continue
        </Button>
      </form>
    </SignUpLayout>
  );
};

export default SignUp; 